import React, { useEffect, useState } from "react";

import DashboardBarChart from "../../CommonComponents/Dashboard/DashboardBarChart/DashboardBarChart";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

function KeyFeatures({isApiKeyFeaturesRunning, keyFeaturesData}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    true
  );


  const keyFeatures = {
    labels: [
      "Rebet button",
      "Social interactions",
      "Easy to read lines",
      "Peer to peer",
    ],
    datasets: [
      {
        data: [
          keyFeaturesData.rebet_button,
          keyFeaturesData.social_interactions.total,
          keyFeaturesData.easy_to_read_lines,
          keyFeaturesData.peer_to_peer,
        ],
        backgroundColor: ["#1ABC9C"],
        borderColor: ["#1ABC9C"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const customOptions = {
    scales: {
      x: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString(),
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#252729",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
        callbacks: {
          label: (tooltipItem) => {
            const index = tooltipItem.dataIndex;

            // Se for "Social interactions", detalha as chaves
            if (index === 1) {
              const { comments, likes, shares } =
                keyFeaturesData.social_interactions;

              return [
                `Total: ${tooltipItem.raw.toLocaleString()}`,
                `Comments: ${comments.toLocaleString()}`,
                `Likes: ${likes.toLocaleString()}`,
                `Shares: ${shares.toLocaleString()}`,
              ];
            }

            // Para os outros valores, exibe normalmente
            return `${tooltipItem.raw.toLocaleString()}`;
          },
        },
      },
    },
  };

  return (
    <DashboardBarChart
      data={keyFeatures}
      title="Key features usage"
      display={true}
      customOptions={customOptions}
      isApiRunning={isApiKeyFeaturesRunning}
    />
  );
}

export default KeyFeatures;
